import Aboutus from 'app/form/Aboutus';
import React from 'react';

const AboutusPage = () => {
	return (
		<div>
			<Aboutus />
		</div>
	);
};

export default AboutusPage;
